<template>
    <div class="d-flex min-vh-100">
        <Aside />
        <main class="flex-grow-1 bg-light">
            <div class="p-4">
                <h2 class="mb-4">Profil</h2>
                <div class="card shadow-sm p-4">
                    <form>
                        <div class="mb-3">
                            <label for="user_name" class="form-label">Nom</label>
                            <input type="text" id="user_name" class="form-control" v-model="user.name" required />
                        </div>
                        <div class="mb-3">
                            <label for="user_email" class="form-label">Email</label>
                            <input type="email" id="user_email" class="form-control" v-model="user.email" required />
                        </div>
                    </form>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import axios from "@/api/axios.js";
import Aside from "@/components/Aside.vue";
import Swal from "sweetalert2";

export default {
    components: {
        Aside,
    },
    data() {
        return {
            // Données de l'utilisateur récupérées de sessionStorage
            user: {
                name: '',
                email: '',
                bio: ''
            }
        };
    },
    mounted() {
        // Récupérer les données de l'utilisateur depuis sessionStorage
        const userData = JSON.parse(sessionStorage.getItem('user'));

        if (userData) {
            this.user.name = userData.firstname + ' ' + userData.lastname;
            this.user.email = userData.email;
        }
    },
};
</script>

<style>
/* Ajoutez ici des styles si nécessaire */
</style>
